/**
 * Common constants used across the application
 */

/**
 * Default limit for fetching full lists without pagination
 * Used for dropdowns, autocompletes, and other UI components that need complete datasets
 */
export const FULL_LIST_LIMIT = 200

/**
 * Minimum search term length required to trigger search queries
 * Used for autocomplete and search suggestion components
 */
export const MIN_SEARCH_LENGTH = 2

/**
 * Standard debounce delay for input handlers (search, filter inputs).
 * Used to batch keystroke-driven network calls.
 */
export const DEBOUNCE_DELAY_MS = 300

// AS400 constraint — every GL account is assigned to Akrochem today; multi-company support is a future backlog item.
export const AKROCHEM_COMPANY_NAME = "Akrochem"

// Checkbox/Radio (42px) + TableCell padding (16px × 2)
export const SELECT_COLUMN_SIZE = 74
